export const GetAllTraits = `
{
  drPostValidTraits(orderBy: { f: posttraitid, o: ASC }, filters:[
    {
      posttraitid: {
        op: IN,
        vl: [13, 14, 12]
      }
    }
  ])
  {
    posttraitid
    name
    internalname
  }
}
`;
